// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__j4b3P","infoBtn":"quickbooks_infoBtn__1_Lqb","formBox":"quickbooks_formBox__22Q9K","formFooter":"quickbooks_formFooter__34szb"};